import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillCompromised = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1801 6.83594C15.2972 6.83593 17.8298 6.52419 17.8298 6.11513C17.8298 5.90082 17.0506 5.70594 15.8426 5.56963L15.2972 3.60186C15.1803 3.1538 14.7127 2.9005 14.2841 3.03695L12.4137 3.60186C12.2579 3.64086 12.102 3.64086 11.9461 3.60186L10.0758 3.03695C9.62786 2.90051 9.1798 3.15382 9.06281 3.60186L8.51731 5.58908C7.29003 5.72538 6.53023 5.92026 6.53023 6.13458C6.53023 6.52419 9.06281 6.83594 12.1801 6.83594Z"
      fill="#565B6D"
    />
    <path
      d="M12.3501 10.928C13.9804 10.928 15.302 9.83046 15.302 8.47654C15.302 7.64196 14.2194 7.6487 12.8053 7.6575C12.6569 7.65843 12.5049 7.65937 12.3501 7.65937C12.1953 7.65937 12.0434 7.65843 11.8951 7.6575C10.4809 7.6487 9.39815 7.64196 9.39815 8.47654C9.39815 9.83046 10.7198 10.928 12.3501 10.928Z"
      fill="#565B6D"
    />
    <path
      d="M19.4746 12.9928L20.3902 15.6813C20.7604 16.7723 20.098 17.9217 19.0072 18.1945L17.6239 18.5062L18.1888 15.0968C18.2668 14.6488 18.1304 14.1812 17.8382 13.8306C17.546 13.4799 17.0978 13.2851 16.6498 13.2851H7.86332C7.39572 13.2851 6.96708 13.48 6.67491 13.8306C6.38274 14.1812 6.24643 14.6488 6.3243 15.0968L6.88921 18.5062L5.50591 18.1945C4.39537 17.9413 3.733 16.7723 4.10319 15.6813L5.01872 12.9929C5.25261 12.2915 5.75911 11.7265 6.40202 11.3953L8.66185 10.2652C9.51914 11.2977 10.8049 11.9407 12.2466 11.9407C13.6882 11.9407 14.974 11.2783 15.8313 10.2652L18.0913 11.3952C18.7342 11.7265 19.2408 12.3108 19.4746 12.9928Z"
      fill="#565B6D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.86318 14.2786H16.6302C16.9808 14.2786 17.2537 14.5903 17.1756 14.9215L16.2405 20.5324C16.2015 20.8051 15.9677 21 15.695 21H8.79829C8.52554 21 8.2918 20.8051 8.25279 20.5324L7.31768 14.9215C7.25927 14.5904 7.51258 14.2786 7.86318 14.2786ZM11.5647 17.649C11.5647 18.0192 11.8765 18.3309 12.2467 18.3309C12.6169 18.3309 12.9286 18.0192 12.9286 17.649C12.9286 17.2788 12.6169 16.967 12.2467 16.967C11.8765 16.967 11.5647 17.2788 11.5647 17.649Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillCompromised)
